export { default as WeightField } from './component';
